<!-- Native-Angular port of account-v2/.../advocacy/group/advocacy.html.
     Same shape as PeopleComponent's template: `ft-branches` replaced by an
     inline <nav>/<ul> using @uirouter/angular's uiSref/uiSrefActive,
     <ui-view> replaced by <ft-ui-view-wrapper> so the AngularJS leaf states
     (bigPicture / contests / audiences / journeys / contest-container modals
     / ftPeopleDetails) render under this Angular shell. -->
<div class="ft-view-body ft-advocacy-body" *ngIf="hasLicense">
    <ft-main-nav />
    <ft-header [modifierClass]="'-tall'" [backgroundImageUrl]="property?.BackgroundImageUrl">
        <div class="ft-content ft-container">
            <h1 class="ft-heading ft-text-plus-5">
                Advocacy
            </h1>
        </div>
        <nav class="ft-nav ft-navbar ft-sections-nav">
            <ul>
                <li uiSrefActive="active">
                    <a uiSref="advocacy.big-picture">the big picture</a>
                </li>
                <li uiSrefActive="active" *ngIf="canSeeCampaigns">
                    <a uiSref="advocacy.contests">campaigns</a>
                </li>
                <li uiSrefActive="active">
                    <a uiSref="advocacy.journeys">journeys</a>
                </li>
            </ul>
        </nav>
    </ft-header>

    <main class="ft-main ft-advocacy-main ft-scroll-anchor">
        <!-- WS5 router-severance: advocacy.{big-picture,contests,audiences,journeys} are all
             native components (contests' + audiences' own child outlets are native <ui-view>
             too). A plain @uirouter/angular <ui-view> hosts them. Done BOTTOM-UP with
             contests.component.html (the nested wrapper) — converting this outer alone while
             contests stayed AngularJS double-rendered Advocacy-Contests (the #83 css revert). -->
        <ui-view />
    </main>
</div>
<div class="ft2 ft2-nav-backdrop" *ngIf="!hasLicense">
    <div class="ft2-page-overlay ft2-bg-advocacy-teaser bg-darker">
        <ft-main-nav [spacing]="true" />
        <section class="ft2-section">
            <div class="ft2-container text-content">
                <h1 class="h1 text-center">Advocacy</h1>
                <div class="row" *ngIf="!totalPropertiesWithLicense">
                    <div class="col-6 col-md-8 col-sm-12">
                        <h2 class="h3">
                            Reach and inspire a massive new audience of dreamers.
                        </h2>
                        <p>
                            Travelers are becoming ambassadors for your brand: an invaluable marketing force helping win
                            over a like-minded audience who are the perfect fit.
                        </p>
                        <p>
                            Switch on Advocacy with the help of your friendly
                            <a href="mailto:support@flip.to">account manager</a>.
                        </p>
                    </div>
                </div>
                <div class="row" *ngIf="totalPropertiesWithLicense != null && totalPropertiesWithLicense > 0">
                    <div class="col-6 col-md-8 col-sm-12">
                        <h2 class="h3">
                            {{totalPropertiesWithLicense}} of your properties are reaching and inspiring a massive
                            new audience of dreamers.
                        </h2>
                        <p>
                            Travelers are becoming ambassadors for your brand: an invaluable marketing force helping win
                            over a like-minded audience who are the perfect fit.
                        </p>
                        <p>
                            <a (click)="showSpaces()">
                                Check out each property to see the impact.
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
